var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[_c('Mail',{attrs:{"emails_list":_vm.document.emails,"attached_files":[
      {
        object: _vm.object,
        document: _vm.document,
      },
    ],"body":_vm.body},on:{"close":function($event){return _vm.$emit('close', $event)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }